<sdc-bo-dialog
  headerTitle="Are you sure you want to delete this Upgrade?"
  [styleClass]="['variant-prominent-title']"
  [attr.data-cy]="'upgrade-delete-modal-' + data?.id">
  <div class="content-wrapper">
    <div>
      <div class="input-line">
        <div>
          <span><b>Name</b></span>
        </div>
        <div>
          <p>{{ data?.name }}</p>
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Description</b></span>
        </div>
        <div>
          <p>{{ data?.description }}</p>
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Goal</b></span>
        </div>
        <div>
          <p>{{ data?.goal }}</p>
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Min. Seats to show</b></span>
        </div>
        <div>
          <p>{{ data?.minSeatsToShow }}</p>
        </div>
      </div>
      <div class="input-line">
        <div>
          <span>
            <b>Visibility</b>
          </span>
        </div>
        <div>
          <p>{{ data?.active }}</p>
        </div>
      </div>
    </div>
    <div class="ms-6">
      <div class="mb-4 title">
        This Upgrade belongs to the following events:
      </div>
      @if (data?.events?.length) {
        <ul class="event-list">
          @for (item of data.events; track item) {
            <li class="event-list-item">
              <span class="event-list-name">{{ item.description }}</span>
              <span class="event-list-date">{{ item.date | date }}</span>
            </li>
          }
        </ul>
      }
    </div>
  </div>
  <ng-container sdc-bo-dialog-footer>
    <sdc-button
      [attr.data-cy]="'upgrade-delete-modal-cancel-button-' + data?.id"
      variant="secondary"
      (onClick)="onDismiss('cancel')">
      Cancel
    </sdc-button>
    <sdc-button
      [attr.data-cy]="'upgrade-delete-modal-confirm-button-' + data?.id"
      variant="destructive"
      (onClick)="onConfirm(data?.id)">
      Permanently delete
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
